// extracted by mini-css-extract-plugin
export default {"phoneLink__iconWrapper":"PhoneLink_phoneLink__iconWrapper__QhSrd","phoneLink__iconWrapper_disabled":"PhoneLink_phoneLink__iconWrapper_disabled__tUdt8"};